module.exports = __webpack_public_path__ + "img/E0A5.de81a1b8.svg";